import { render, staticRenderFns } from "./OptionCardEditElement.vue?vue&type=template&id=4a42ebf0&scoped=true"
import script from "./OptionCardEditElement.vue?vue&type=script&lang=js"
export * from "./OptionCardEditElement.vue?vue&type=script&lang=js"
import style0 from "./OptionCardEditElement.vue?vue&type=style&index=0&id=4a42ebf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a42ebf0",
  null
  
)

export default component.exports